<section class="checkout-summary" *ngIf="cart">
  <p class="checkout-summary__eyebrow" i18n="@@checkout.summary.eyebrow">付款概覽 Summary</p>

  <div class="checkout-summary__row">
    <span i18n="@@checkout.summary.subtotal">商品總額</span>
    <span class="checkout-summary__amount">${{ cart.subTotal | number }}</span>
  </div>
  <div class="checkout-summary__row">
    <span i18n="@@checkout.summary.discount">折扣</span>
    <span class="checkout-summary__amount">${{ cart.discount | number }}</span>
  </div>
  <div class="checkout-summary__row checkout-summary__row--last">
    <span i18n="@@checkout.summary.shipping">運費</span>
    <span class="checkout-summary__amount">${{ cart.shippingFee | number }}</span>
  </div>

  <div class="checkout-summary__total">
    <span i18n="@@checkout.summary.total">應付金額</span>
    <span class="checkout-summary__total-amount">${{ cart.grandTotal | number }}</span>
  </div>

  <div class="checkout-summary__promo">
    <app-coupon-section [cart]="cart"></app-coupon-section>
  </div>
</section>
